<script lang="ts">
	import IKS from "./IKS.svelte";
	import { CircleWithWarning } from "@hitit/new_ui/src";
	import PlainTextEditor from "../../../components/place/PlainTextEditor.svelte";
	//

	import { createEventDispatcher } from "svelte";
	import { t } from "@hitit/hub/src/stores";
	import EditBuisnessHourRow from "../store/EditBuisnessHourRow.svelte";

	type Day = "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat" | "Sun";

	type OpenHour = {
		day: Day;
		open: string;
		close: string;
		dayOff: boolean;
	};
	export let breakTime: string | null = null;
	export let editmode = false;
	export let buisnesshours: OpenHour[] = [];
	//
	const midnight = "23:59";
	const dispatch = createEventDispatcher();
	const buisnesshourFilterCallback = (time: OpenHour) =>
		time.dayOff || (time.close && time.open);
	const timeArrange = (start: string, end: string) => {
		let close = end === midnight ? "24:00" : end;
		let nextDay =
			Number(start.replace(":", "")) > Number(end.replace(":", ""))
				? "다음날 "
				: "";
		return start + " - " + nextDay + close;
	};
	//
	function breaktimeHandler(e: { detail: { html: string } }) {
		dispatch("UPDATE_BREAKTIME", {
			html: e.detail.html,
		});
	}

</script>

<IKS name={'영업시간'}>
	<img
		src="/img/icons/placebuisnesshour.png"
		alt="Buisnesshour Icon"
		slot="image" />
	<div class="container" class:editmode>
		{#if editmode}
			<div class="input-table">
				{#each buisnesshours as hour}
					<EditBuisnessHourRow
						day={$t(`hub.place.${hour.day}`)}
						bind:dayoff={hour.dayOff}
						bind:open={hour.open}
						bind:close={hour.close} />
				{/each}
			</div>
		{:else}
			<div class="static-table">
				{#each buisnesshours.filter(buisnesshourFilterCallback) as time}
					<div class="static-row" class:dayOff={time.dayOff}>
						<span>{$t(`hub.place.${time.day}`)}</span>
						<span>{time.dayOff ? $t('hub.place.Off') : timeArrange(time.open, time.close)}</span>
					</div>
				{:else}
					<div class="no-hour">
						<div class="circle">
							<CircleWithWarning />
						</div>
						<p class="desc">{$t('hub.place.No_buisnesshour')}</p>
					</div>
				{/each}
			</div>
		{/if}
		{#if editmode}
			<div class="breaktime editor">
				<PlainTextEditor
					placeholder={$t('hub.place.Breaktime_placeholder')}
					lengthLimit={100}
					lineLimit={5}
					value={breakTime ? breakTime : ''}
					on:UPDATE_TEXT={breaktimeHandler} />
			</div>
			<span class="maximum">{$t('hub.place.Maximum_100')}</span>
		{:else}
			<div class="breaktime">
				{@html breakTime || ''}
			</div>
		{/if}
	</div>
</IKS>

<style lang="scss">
	@import "../../../variables.scss";
	img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
	.container {
		display: flex;
		flex-direction: column;
		gap: 10px;
		padding-left: 28px;
		/*  */
		&.editmode {
			/*  */
			gap: 20px;
			padding-left: 0px;
		}
		.input-table {
			display: flex;
			flex-direction: column;
			gap: 14px;

			:global(.container .day) {
				font-weight: 500;
				font-size: 1rem;
			}
		}
		.static-table {
			display: flex;
			flex-direction: column;
			gap: 10px;

			.static-row {
				font-weight: 500;
				color: #46474b;
				display: flex;
				gap: 20px;
				&.dayOff {
					color: #f36464;
				}
			}
		}

		.no-hour {
			display: flex;
			align-items: center;
			gap: 10px;
			color: #46474b;
			.circle {
				width: 20px;
				height: 20px;
			}
		}

		.breaktime {
			color: #6d6f76;
			border-radius: 5px;
			word-break: break-all;
			@include appleAdjustTextForSize(14);

			&.editor {
				background-color: #f0f0f4;
				position: relative;
				:global(.plainTextEditor .ql-editor) {
					min-height: 70px;
					border-radius: 5px;
					padding: 10px;
					background-color: #f0f0f4;
					color: #6d6f76;
					line-height: 25px;
				}
				:global(.plainTextEditor .ql-editor:focus) {
					outline: 0px solid transparent;
				}
				:global(.plainTextEditor .ql-editor.ql-blank:before) {
					color: #bcbfc3;
					content: attr(data-placeholder);
					pointer-events: none;
					position: absolute;
					top: 9px;
					left: 10px;
				}

				~ .maximum {
					width: 100%;
					text-align: right;
					color: #6d6f76;
					font-size: 0.875rem;
					margin-top: -16px;
				}
			}
		}
	}

	@include DesktopSize {
		.container {
			padding-left: 38px;

			&.editmode {
				padding-left: 38px;
			}
			.static-table {
				gap: 15px;
				.static-row {
					font-size: 1.25rem;
				}
			}
			.input-table {
				max-width: 369px;
				:global(.container .day) {
					font-size: 1.25rem;
				}
				:global(.container .time .select) {
					height: 30px;
				}
			}
			.breaktime {
				@include appleAdjustTextForSize(14, false);

				&.editor {
					max-width: 555px;
					:global(.plainTextEditor .ql-editor) {
						font-size: 1.125rem;
						min-height: 90px;
					}

					:global(.plainTextEditor .ql-editor.ql-blank:before) {
						font-size: 1.125rem;
					}

					~ .maximum {
						max-width: 555px;
						font-size: 1rem;
						margin-top: -10px;
					}
				}
			}

			.no-hour {
				.circle {
					width: 24px;
					height: 24px;
				}
				.desc {
					font-size: 1.25rem;
				}
			}
		}
	}

</style>
